import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from './Login';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route
      exact
      path="/"
      render={({ location }) => {
        const { hash } = location;
        return hash ? <Redirect to={hash.replace('#', '')} /> : <Login />;
      }}
    />
    <Route exact path="/login">
      <Login />
    </Route>
  </Switch>
);

export default Routes;
